import { render, staticRenderFns } from "./ShopWealthRecordListForShop.vue?vue&type=template&id=4853e33f&scoped=true&lang=pug&"
import script from "./ShopWealthRecordListForShop.vue?vue&type=script&lang=ts&"
export * from "./ShopWealthRecordListForShop.vue?vue&type=script&lang=ts&"
import style0 from "./ShopWealthRecordListForShop.vue?vue&type=style&index=0&id=4853e33f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4853e33f",
  null
  
)

export default component.exports